import React from "react";
import ButtonIconH from "./ButtonIconH";
import "../css/SummarySectionBox.css";

export default function SummarySectionBox({
  name,
  active,
  numElements,
  onOpen,
}) {
  return (
    <div
      className={`ssb-container ${numElements > 0 || active ? "ssb-fill" : ""}`}
    >
      <span className="section-content-title">{`${name} ${
        numElements >= 0 ? `(${numElements})` : ""
      }`}</span>
      <ButtonIconH text="Abrir" small onClick={onOpen}></ButtonIconH>
    </div>
  );
}
